module.exports = __webpack_public_path__ + "static/img/VARESE-MAPLE.9649273.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/VARESE-MAPLE.png
// module id = MWYl
// module chunks = 0